import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Home Services",
    keywords: [
      "plumber",
      "plumbing",
      "electrician",
      "electrical service",
      "hvac",
      "heating",
      "cooling",
      "air conditioning",
      "furnace",
      "handyman",
      "locksmith",
      "pest ",
      "pest control",
      "exterminator",
      "termite",
      "carpenter",
      "roofing",
      "gutter",
      "window cleaning",
      "carpet cleaning",
      "maid service",
      "house cleaning",
      "cleaning service",
      "junk removal",
      "moving service",
      "movers",
      "appliance repair",
      "garage door",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [];
